<ng-template #template>
    <div class="modal-header">
      <h4 class="modal-title">
        {{header ? header : 'Thank You!'}}
      </h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div>{{ Msg }}</div>
      <button type="button" class="btn btn-sm btnDelete mr-2" (click)="confirm(true)">
       {{'OK'}}
      </button>
    </div>  
    
</ng-template>
